<div class="storeNameOuter" *ngIf="superAdminLoggedIn">
  <span class="storeName">
    <i class="fa fa-dot-circle-o pulsate"></i>
    {{storeName?.split('.')[0]}}
  </span>
</div>

<div class="content-blk">
  <div class="sp-admin-list-outer-page">
    <div class="container">
      <!-- Header Section -->
      <div class="st-top-head spc-top-head-lt">
        <div class="row">
          <div class="col-sm-6">
            <div class="srch-flt-rt">
              <h2>Create Your Products</h2>
              <p class="text-muted">Upload a new design or choose from saved designs for this store</p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="text-right">
              <button mat-raised-button class="mat-btn" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back to Products
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="white-background upload-design-content">
        <!-- Info Banner -->
        <div class="info-banner">
          <i class="fa fa-info-circle"></i>
          <span>Showing designs for selected store only</span>
        </div>

        <!-- Tab Navigation -->
        <div class="design-tabs">
          <button
            class="tab-button"
            [class.active]="activeTab === 'upload'"
            (click)="activeTab = 'upload'">
            <i class="fa fa-upload"></i> Upload New
          </button>
          <button
            class="tab-button"
            [class.active]="activeTab === 'saved'"
            (click)="activeTab = 'saved'">
            <i class="fa fa-folder-open"></i> Saved Designs ({{savedDesignsTotal}})
          </button>
        </div>

        <!-- Upload Tab Content -->
        <div class="tab-content" *ngIf="activeTab === 'upload'">
          <div class="upload-section">
            <!-- File Preview Section - Now at TOP -->
            <div class="file-preview file-preview-top" *ngIf="selectedFile">
              <div class="preview-header">
                <h4>Selected File</h4>
                <button class="btn-remove" (click)="removeFile()">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="preview-content">
                <div class="file-thumbnail" *ngIf="filePreviewUrl">
                  <img [src]="filePreviewUrl" alt="File preview">
                </div>
                <div class="file-icon" *ngIf="!filePreviewUrl">
                  <i class="fa" [ngClass]="getFileIcon()"></i>
                </div>
                <div class="file-details">
                  <div class="file-name">{{selectedFile.name}}</div>
                  <div class="file-size text-muted">{{formatFileSize(selectedFile.size)}}</div>
                </div>
              </div>

              <!-- PDF is converted to an image before upload; this can take a moment on a large page -->
              <div class="upload-converting" *ngIf="isConvertingPdf">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Converting PDF to image...</span>
              </div>

              <!-- Upload Progress - Shows automatically -->
              <div class="upload-progress" *ngIf="isUploading && !isConvertingPdf">
                <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
                <span class="progress-text">{{uploadProgress}}%</span>
              </div>

              <!-- Upload Complete Message -->
              <div class="upload-complete" *ngIf="uploadComplete">
                <i class="fa fa-check-circle"></i>
                <span>File uploaded successfully</span>
              </div>
            </div>

            <div
              class="upload-dropzone"
              [class.has-file]="selectedFile"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
              [class.dragover]="isDragging">

              <div class="upload-icon" *ngIf="!selectedFile">
                <i class="fa fa-cloud-upload"></i>
              </div>

              <h3 *ngIf="!selectedFile">Drag & drop your design here</h3>
              <p class="text-muted" *ngIf="!selectedFile">or click to browse from your computer</p>

              <input
                type="file"
                #fileInput
                (change)="onFileSelected($event)"
                accept=".png,.jpg,.jpeg,.pdf,.svg"
                style="display: none;">

              <button
                mat-raised-button
                class="mat-btn mat-primary"
                (click)="fileInput.click()">
                <i class="fa fa-folder-open"></i> {{ selectedFile ? 'Change File' : 'Choose File' }}
              </button>

              <div class="upload-info" *ngIf="!selectedFile">
                <small class="text-muted">
                  Accepted formats: PNG, JPG, PDF, SVG • Maximum file size: 25 MB
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Saved Designs Tab Content -->
        <div class="tab-content" *ngIf="activeTab === 'saved'">
          <div class="saved-designs-section">
            <!-- Search Bar -->
            <div class="search-bar">
              <mat-form-field class="full-width">
                <input
                  matInput
                  placeholder="Search designs..."
                  [(ngModel)]="searchText"
                  (input)="onSearchChange()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <!-- Initial page load spinner -->
            <div class="loading-state" *ngIf="isLoadingDesigns">
              <mat-spinner></mat-spinner>
              <p>Loading designs...</p>
            </div>

            <!-- Results: total count + scrollable infinite grid -->
            <ng-container *ngIf="!isLoadingDesigns">
              <p class="designs-count text-muted" *ngIf="savedDesigns.length > 0">
                Showing {{savedDesigns.length}} of {{savedDesignsTotal}} design(s)
              </p>

              <div *ngIf="savedDesigns.length > 0">

                <div class="designs-grid">
                <div class="design-card" *ngFor="let design of savedDesigns">
                  <div class="design-thumbnail">
                    <!-- PDFs are rasterized to a PNG data URL first (a browser cannot decode a PDF
                         inside an <img>), so every design binds through the same <img> here. -->
                    <img
                      *ngIf="designThumbnailSrc(design) as thumbSrc"
                      [src]="thumbSrc"
                      alt="{{design.name}}"
                      (error)="onThumbnailError($event)">

                    <!-- Shown only while a PDF is still rasterizing. -->
                    <div class="design-thumbnail-loading" *ngIf="isPdfRendering(design)">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>

                    <!-- Shown when a PDF could not be rendered at all. -->
                    <div class="design-file-tile" *ngIf="isPdfRenderFailed(design)">
                      <i class="fa fa-file-pdf-o"></i>
                      <span class="design-file-type">PDF</span>
                    </div>
                  </div>
                  <div class="design-info">
                    <h4 class="design-name">{{design.name}}</h4>
                    <p class="design-date text-muted">
                      <i class="fa fa-clock-o"></i> {{design.createdDate | date:'short'}}
                    </p>
                  </div>
                  <div class="design-actions">
                    <button
                      mat-raised-button
                      class="mat-btn mat-primary btn-select"
                      (click)="selectDesign(design)">
                      <i class="fa fa-check"></i> Select
                    </button>
                  </div>
                </div>

                <!-- Inline spinner while fetching next page -->
                <div class="load-more-spinner" *ngIf="isLoadingMore">
                  <i class="fa fa-spinner fa-spin"></i> Loading more...
                </div>

                <!-- End-of-list message -->
                <div class="all-loaded-msg" *ngIf="allDesignsLoaded && savedDesigns.length > 0">
                  All {{savedDesignsTotal}} design(s) loaded.
                </div>

                <!-- IntersectionObserver sentinel: when this scrolls into view the next page loads.
                     Always rendered (even when allDesignsLoaded) — onScroll() guard handles the stop. -->
                <div #scrollSentinel class="scroll-sentinel" aria-hidden="true"></div>
                </div><!-- /.designs-grid -->
              </div><!-- infinite-scroll wrapper -->

              <!-- Empty State -->
              <div class="empty-state" *ngIf="savedDesigns.length === 0">
                <div class="empty-icon">
                  <i class="fa fa-folder-open-o"></i>
                </div>
                <h3>No saved designs found</h3>
                <p class="text-muted">Upload a new design to get started</p>
                <button
                  mat-raised-button
                  class="mat-btn mat-primary"
                  (click)="activeTab = 'upload'">
                  <i class="fa fa-upload"></i> Upload New Design
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
